import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import BeforeAfter from "./BeforeAfter";

export default function TransformationsCarousel({ items = [] }) {
  const [active, setActive] = useState(0);
  if (!items.length) return null;
  const cur = items[active];

  return (
    <section className="py-20 lg:py-28 bg-paper" data-testid="before-after-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-center mb-10">
          <div className="lg:col-span-5">
            <div className="eyebrow mb-3">Real transformations</div>
            <h2 className="font-display text-4xl lg:text-5xl text-dark">From overgrown to <span className="italic">unforgettable.</span></h2>
            <p className="mt-5 text-dark/70 text-lg">Drag the slider to reveal what a Last Cut transformation looks like — straight from recent Central Belt projects.</p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link to="/quote" className="btn-accent text-base px-7 py-4 shadow-lg hover:scale-[1.02]" data-testid="ba-quote-btn">Get Your Free Quote <ArrowRight size={18}/></Link>
              <Link to="/projects" className="btn-ghost">See more <ArrowRight size={16}/></Link>
            </div>
          </div>

          <div className="lg:col-span-7">
            <BeforeAfter before={cur.before} after={cur.after} beforeAlt={`${cur.title} — before transformation by Last Cut Landscaping`} afterAlt={`${cur.title} — after transformation by Last Cut Landscaping`}/>
            <div className="mt-5 flex items-center justify-between gap-3">
              <div>
                <div className="font-display text-xl text-dark">{cur.title}</div>
                <div className="text-sm text-dark/60">{cur.subtitle}</div>
              </div>
              <div className="flex gap-2">
                {items.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActive(i)}
                    aria-label={`Transformation ${i+1}`}
                    data-testid={`ba-tab-${i}`}
                    className={`h-1.5 rounded-full transition-all ${active === i ? "w-10 bg-dark" : "w-6 bg-dark/20 hover:bg-dark/40"}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Thumbnails of all pairs */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {items.map((it, i) => (
            <button key={i} onClick={() => setActive(i)} className={`relative overflow-hidden rounded-2xl aspect-[4/3] group transition-all ${active === i ? "ring-2 ring-dark ring-offset-2 ring-offset-paper" : "opacity-80 hover:opacity-100"}`} data-testid={`ba-thumb-${i}`}>
              <img src={it.after} alt={`${it.title} thumbnail`} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"/>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-dark/85 to-transparent p-3 text-left">
                <div className="text-white text-xs font-semibold">{it.title}</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
